import FiveStarsIcon from './five-stars.svg';

export { FiveStarsIcon };

import aslanJpg from './aslan.jpg';
import aslanWebp from './aslan.webp';

import busterJpg from './buster.jpg';
import busterWebp from './buster.webp';

import candyJpg from './candy.jpg';
import candyWebp from './candy.webp';

import charleyJpg from './charley.jpg';
import charleyWebp from './charley.webp';

import doozaAndTrinityJpg from './doozaandtrinity.jpg';
import doozaAndTrinityWebp from './doozaandtrinity.webp';

import duncanJpg from './duncan.jpg';
import duncanWebp from './duncan.webp';

import elvisJpg from './elvis.jpg';
import elvisWebp from './elvis.webp';

import francisJpg from './francis.jpg';
import francisWebp from './francis.webp';

import gabiJpg from './gabi.jpg';
import gabiWebp from './gabi.webp';

import ghostJpg from './ghost.jpg';
import ghostWebp from './ghost.webp';

import gingerJpg from './ginger.jpg';
import gingerWebp from './ginger.webp';

import gretaJpg from './greta.jpg';
import gretaWebp from './greta.webp';

import jacJpg from './jac.jpg';
import jacWebp from './jac.webp';

import jaxJpg from './jax.jpg';
import jaxWebp from './jax.webp';

import kennyJpg from './kenny.jpg';
import kennyWebp from './kenny.webp';

import kimberJpg from './kimber.jpg';
import kimberWebp from './kimber.webp';

import kodaJpg from './koda.jpg';
import kodaWebp from './koda.webp';

import loki1Jpg from './loki-1.jpg';
import loki1Webp from './loki-1.webp';

import lokiJpg from './loki.jpg';
import lokiWebp from './loki.webp';

import lukeJpg from './luke.jpg';
import lukeWebp from './luke.webp';

import lunaJpg from './luna.jpg';
import lunaWebp from './luna.webp';

import macyAndLillyJpg from './macyandlilly.jpg';
import macyAndLillyWebp from './macyandlilly.webp';

import maxJpg from './max.jpg';
import maxWebp from './max.webp';

import mayJpg from './may.jpg';
import mayWebp from './may.webp';

import miaJpg from './mia.jpg';
import miaWebp from './mia.webp';

import mikaJpg from './mika.jpg';
import mikaWebp from './mika.webp';

import mikeyJpg from './mikey.jpg';
import mikeyWebp from './mikey.webp';

import mochiJpg from './mochi.jpg';
import mochiWebp from './mochi.webp';

import oogieJpg from './oogie.jpg';
import oogieWebp from './oogie.webp';

import oscarJpg from './oscar.jpg';
import oscarWebp from './oscar.webp';

import riverJpg from './river.jpg';
import riverWebp from './river.webp';

import rockyJpg from './rocky.jpg';
import rockyWebp from './rocky.webp';

import simba1Jpg from './simba-1.jpg';
import simba1Webp from './simba-1.webp';

import simbaJpg from './simba.jpg';
import simbaWebp from './simba.webp';

import treJpg from './tre.jpg';
import treWebp from './tre.webp';

import unoJpg from './uno.jpg';
import unoWebp from './uno.webp';

import vivienneKissesJpg from './viviennekisses.jpg';
import vivienneKissesWebp from './viviennekisses.webp';

import winnieJpg from './winnie.jpg';
import winnieWebp from './winnie.webp';

import winstonAndGusJpg from './winstonandgus.jpg';
import winstonAndGusWebp from './winstonandgus.webp';

export const aslanSources = {
  webP: aslanWebp,
  jpg: aslanJpg,
};

export const busterSources = {
  webP: busterWebp,
  jpg: busterJpg,
};

export const candySources = {
  webP: candyWebp,
  jpg: candyJpg,
};

export const charleySources = {
  webP: charleyWebp,
  jpg: charleyJpg,
};

export const doozaAndTrinitySources = {
  webP: doozaAndTrinityWebp,
  jpg: doozaAndTrinityJpg,
};

export const duncanSources = {
  webP: duncanWebp,
  jpg: duncanJpg,
};

export const elvisSources = {
  webP: elvisWebp,
  jpg: elvisJpg,
};

export const francisSources = {
  webP: francisWebp,
  jpg: francisJpg,
};

export const gabiSources = {
  webP: gabiWebp,
  jpg: gabiJpg,
};

export const ghostSources = {
  webP: ghostWebp,
  jpg: ghostJpg,
};

export const gingerSources = {
  webP: gingerWebp,
  jpg: gingerJpg,
};

export const gretaSources = {
  webP: gretaWebp,
  jpg: gretaJpg,
};

export const jacSources = {
  webP: jacWebp,
  jpg: jacJpg,
};

export const jaxSources = {
  webP: jaxWebp,
  jpg: jaxJpg,
};

export const kennySources = {
  webP: kennyWebp,
  jpg: kennyJpg,
};

export const kimberSources = {
  webP: kimberWebp,
  jpg: kimberJpg,
};

export const kodaSources = {
  webP: kodaWebp,
  jpg: kodaJpg,
};

export const loki1Sources = {
  webP: loki1Webp,
  jpg: loki1Jpg,
};

export const lokiSources = {
  webP: lokiWebp,
  jpg: lokiJpg,
};

export const lukeSources = {
  webP: lukeWebp,
  jpg: lukeJpg,
};

export const lunaSources = {
  webP: lunaWebp,
  jpg: lunaJpg,
};

export const macyAndLillySources = {
  webP: macyAndLillyWebp,
  jpg: macyAndLillyJpg,
};

export const maxSources = {
  webP: maxWebp,
  jpg: maxJpg,
};

export const maySources = {
  webP: mayWebp,
  jpg: mayJpg,
};

export const miaSources = {
  webP: miaWebp,
  jpg: miaJpg,
};

export const mikaSources = {
  webP: mikaWebp,
  jpg: mikaJpg,
};

export const mikeySources = {
  webP: mikeyWebp,
  jpg: mikeyJpg,
};

export const mochiSources = {
  webP: mochiWebp,
  jpg: mochiJpg,
};

export const oogieSources = {
  webP: oogieWebp,
  jpg: oogieJpg,
};

export const oscarSources = {
  webP: oscarWebp,
  jpg: oscarJpg,
};

export const riverSources = {
  webP: riverWebp,
  jpg: riverJpg,
};

export const rockySources = {
  webP: rockyWebp,
  jpg: rockyJpg,
};

export const simba1Sources = {
  webP: simba1Webp,
  jpg: simba1Jpg,
};

export const simbaSources = {
  webP: simbaWebp,
  jpg: simbaJpg,
};

export const treSources = {
  webP: treWebp,
  jpg: treJpg,
};

export const unoSources = {
  webP: unoWebp,
  jpg: unoJpg,
};

export const vivienneKissesSources = {
  webP: vivienneKissesWebp,
  jpg: vivienneKissesJpg,
};

export const winnieSources = {
  webP: winnieWebp,
  jpg: winnieJpg,
};

export const winstonAndGusSources = {
  webP: winstonAndGusWebp,
  jpg: winstonAndGusJpg,
};
